export const LOCATION_ACTION = {
  GET_CITY_LIST: "LOCATION_ACTION/GET_CITY_LIST",
  GET_DISTRICT_LIST: "LOCATION_ACTION/GET_DISTRICT_LIST",
  GET_WARD_LIST: "LOCATION_ACTION/GET_WARD_LIST",
};
